import { j as n } from "../../../../_virtual/jsx-runtime.js";
const e = 30, o = 40, b = ({
  label: a,
  icon: r,
  position: s,
  viewBox: t
}) => {
  const m = s === "left" ? Number(t.x) + Number(t.width) - e : Number(t.x) - Number(t.width) + e, f = Number(t.y) - o, l = s === "left" && !r ? 0 : 25;
  return /* @__PURE__ */ n.jsxs("g", { transform: `translate(${m}, ${f})`, children: [
    r,
    /* @__PURE__ */ n.jsx("text", { fontSize: "12", transform: `translate(${l}, 14)`, children: a })
  ] });
};
export {
  b as default
};
